export const angebote_data = [
  {
    name: 'Neukölln',
    zeit: '2023-Q3',
    _angebote_kauf: 727,
    _angebote_miete: 329,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2023-Q3',
    _angebote_kauf: 2206,
    _angebote_miete: 616,
  },
  {
    name: 'Treptow-Köpenick',
    zeit: '2023-Q3',
    _angebote_kauf: 741,
    _angebote_miete: 738,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q3',
    _angebote_kauf: 583,
    _angebote_miete: 262,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q3',
    _angebote_kauf: 1471,
    _angebote_miete: 705,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q3',
    _angebote_kauf: 411,
    _angebote_miete: 345,
  },
  {
    name: 'Marzahn-Hellersdorf',
    zeit: '2023-Q3',
    _angebote_kauf: 148,
    _angebote_miete: 282,
  },
  {
    name: 'Steglitz-Zehlendorf',
    zeit: '2023-Q3',
    _angebote_kauf: 1245,
    _angebote_miete: 413,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q3',
    _angebote_kauf: 357,
    _angebote_miete: 331,
  },
  {
    name: 'Tempelhof-Schöneberg',
    zeit: '2023-Q3',
    _angebote_kauf: 1161,
    _angebote_miete: 334,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2023-Q3',
    _angebote_kauf: 1365,
    _angebote_miete: 385,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q3',
    _angebote_kauf: 1525,
    _angebote_miete: 568,
  },
  {
    name: 'Friedrichshain',
    zeit: '2023-Q3',
    _angebote_kauf: 965,
    _angebote_miete: 251,
  },
  {
    name: 'Tempelhof',
    zeit: '2023-Q3',
    _angebote_kauf: 145,
    _angebote_miete: 32,
  },
  {
    name: 'Wedding',
    zeit: '2023-Q3',
    _angebote_kauf: 232,
    _angebote_miete: 81,
  },
  {
    name: 'Kreuzberg',
    zeit: '2023-Q3',
    _angebote_kauf: 400,
    _angebote_miete: 132,
  },
  {
    name: 'Charlottenburg',
    zeit: '2023-Q3',
    _angebote_kauf: 926,
    _angebote_miete: 249,
  },
  {
    name: 'Köpenick',
    zeit: '2023-Q3',
    _angebote_kauf: 286,
    _angebote_miete: 273,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q3',
    _angebote_kauf: 470,
    _angebote_miete: 182,
  },
  {
    name: 'Steglitz',
    zeit: '2023-Q3',
    _angebote_kauf: 426,
    _angebote_miete: 72,
  },
  {
    name: 'Schöneberg',
    zeit: '2023-Q3',
    _angebote_kauf: 431,
    _angebote_miete: 106,
  },
  {
    name: 'Wilmersdorf',
    zeit: '2023-Q3',
    _angebote_kauf: 747,
    _angebote_miete: 169,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q3',
    _angebote_kauf: 595,
    _angebote_miete: 316,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q3',
    _angebote_kauf: 362,
    _angebote_miete: 82,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q3',
    _angebote_kauf: 236,
    _angebote_miete: 80,
  },
  {
    name: 'Zehlendorf',
    zeit: '2023-Q3',
    _angebote_kauf: 224,
    _angebote_miete: 88,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q3',
    _angebote_kauf: 67,
    _angebote_miete: 23,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q3',
    _angebote_kauf: 160,
    _angebote_miete: 62,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q1',
    _angebote_kauf: 613,
    _angebote_miete: 250,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2023-Q1',
    _angebote_kauf: 1992,
    _angebote_miete: 553,
  },
  {
    name: 'Treptow-Köpenick',
    zeit: '2023-Q1',
    _angebote_kauf: 756,
    _angebote_miete: 755,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q1',
    _angebote_kauf: 488,
    _angebote_miete: 246,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q1',
    _angebote_kauf: 1464,
    _angebote_miete: 644,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q1',
    _angebote_kauf: 389,
    _angebote_miete: 344,
  },
  {
    name: 'Marzahn-Hellersdorf',
    zeit: '2023-Q1',
    _angebote_kauf: 129,
    _angebote_miete: 367,
  },
  {
    name: 'Steglitz-Zehlendorf',
    zeit: '2023-Q1',
    _angebote_kauf: 1120,
    _angebote_miete: 370,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q1',
    _angebote_kauf: 357,
    _angebote_miete: 329,
  },
  {
    name: 'Tempelhof-Schöneberg',
    zeit: '2023-Q1',
    _angebote_kauf: 1034,
    _angebote_miete: 368,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2023-Q1',
    _angebote_kauf: 1257,
    _angebote_miete: 288,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q1',
    _angebote_kauf: 1585,
    _angebote_miete: 567,
  },
  {
    name: 'Friedrichshain',
    zeit: '2023-Q1',
    _angebote_kauf: 888,
    _angebote_miete: 185,
  },
  {
    name: 'Tempelhof',
    zeit: '2023-Q1',
    _angebote_kauf: null,
    _angebote_miete: null,
  },
  {
    name: 'Wedding',
    zeit: '2023-Q1',
    _angebote_kauf: 234,
    _angebote_miete: 88,
  },
  {
    name: 'Kreuzberg',
    zeit: '2023-Q1',
    _angebote_kauf: 367,
    _angebote_miete: 100,
  },
  {
    name: 'Charlottenburg',
    zeit: '2023-Q1',
    _angebote_kauf: 869,
    _angebote_miete: 242,
  },
  {
    name: 'Köpenick',
    zeit: '2023-Q1',
    _angebote_kauf: 239,
    _angebote_miete: 242,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q1',
    _angebote_kauf: 382,
    _angebote_miete: 118,
  },
  {
    name: 'Steglitz',
    zeit: '2023-Q1',
    _angebote_kauf: 409,
    _angebote_miete: null,
  },
  {
    name: 'Schöneberg',
    zeit: '2023-Q1',
    _angebote_kauf: 419,
    _angebote_miete: 95,
  },
  {
    name: 'Wilmersdorf',
    zeit: '2023-Q1',
    _angebote_kauf: 697,
    _angebote_miete: 141,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q1',
    _angebote_kauf: 573,
    _angebote_miete: 273,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q1',
    _angebote_kauf: 298,
    _angebote_miete: 77,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q1',
    _angebote_kauf: 263,
    _angebote_miete: 92,
  },
  {
    name: 'Zehlendorf',
    zeit: '2023-Q1',
    _angebote_kauf: 173,
    _angebote_miete: 52,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q1',
    _angebote_kauf: 66,
    _angebote_miete: 39,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q1',
    _angebote_kauf: 172,
    _angebote_miete: 69,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q2',
    _angebote_kauf: 672,
    _angebote_miete: 256,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2023-Q2',
    _angebote_kauf: 2222,
    _angebote_miete: 545,
  },
  {
    name: 'Treptow-Köpenick',
    zeit: '2023-Q2',
    _angebote_kauf: 817,
    _angebote_miete: 856,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q2',
    _angebote_kauf: 582,
    _angebote_miete: 237,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q2',
    _angebote_kauf: 1484,
    _angebote_miete: 634,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q2',
    _angebote_kauf: 405,
    _angebote_miete: 337,
  },
  {
    name: 'Marzahn-Hellersdorf',
    zeit: '2023-Q2',
    _angebote_kauf: 133,
    _angebote_miete: 294,
  },
  {
    name: 'Steglitz-Zehlendorf',
    zeit: '2023-Q2',
    _angebote_kauf: 1250,
    _angebote_miete: 380,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q2',
    _angebote_kauf: 371,
    _angebote_miete: 344,
  },
  {
    name: 'Tempelhof-Schöneberg',
    zeit: '2023-Q2',
    _angebote_kauf: 1234,
    _angebote_miete: 319,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2023-Q2',
    _angebote_kauf: 1396,
    _angebote_miete: 341,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q2',
    _angebote_kauf: 1583,
    _angebote_miete: 569,
  },
  {
    name: 'Friedrichshain',
    zeit: '2023-Q2',
    _angebote_kauf: 986,
    _angebote_miete: 218,
  },
  {
    name: 'Tempelhof',
    zeit: '2023-Q2',
    _angebote_kauf: null,
    _angebote_miete: null,
  },
  {
    name: 'Wedding',
    zeit: '2023-Q2',
    _angebote_kauf: 246,
    _angebote_miete: 92,
  },
  {
    name: 'Kreuzberg',
    zeit: '2023-Q2',
    _angebote_kauf: 412,
    _angebote_miete: 121,
  },
  {
    name: 'Charlottenburg',
    zeit: '2023-Q2',
    _angebote_kauf: 937,
    _angebote_miete: 222,
  },
  {
    name: 'Köpenick',
    zeit: '2023-Q2',
    _angebote_kauf: 293,
    _angebote_miete: 312,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q2',
    _angebote_kauf: 430,
    _angebote_miete: 139,
  },
  {
    name: 'Steglitz',
    zeit: '2023-Q2',
    _angebote_kauf: 398,
    _angebote_miete: null,
  },
  {
    name: 'Schöneberg',
    zeit: '2023-Q2',
    _angebote_kauf: 441,
    _angebote_miete: 97,
  },
  {
    name: 'Wilmersdorf',
    zeit: '2023-Q2',
    _angebote_kauf: 773,
    _angebote_miete: 149,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q2',
    _angebote_kauf: 586,
    _angebote_miete: 271,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q2',
    _angebote_kauf: 365,
    _angebote_miete: 81,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q2',
    _angebote_kauf: 257,
    _angebote_miete: 83,
  },
  {
    name: 'Zehlendorf',
    zeit: '2023-Q2',
    _angebote_kauf: 227,
    _angebote_miete: 62,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q2',
    _angebote_kauf: 73,
    _angebote_miete: 28,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q2',
    _angebote_kauf: 163,
    _angebote_miete: 74,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q4',
    _angebote_kauf: 765,
    _angebote_miete: 333,
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    zeit: '2023-Q4',
    _angebote_kauf: 2296,
    _angebote_miete: 721,
  },
  {
    name: 'Treptow-Köpenick',
    zeit: '2023-Q4',
    _angebote_kauf: 755,
    _angebote_miete: 700,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q4',
    _angebote_kauf: 620,
    _angebote_miete: 252,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q4',
    _angebote_kauf: 1565,
    _angebote_miete: 938,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q4',
    _angebote_kauf: 462,
    _angebote_miete: 359,
  },
  {
    name: 'Marzahn-Hellersdorf',
    zeit: '2023-Q4',
    _angebote_kauf: 141,
    _angebote_miete: 304,
  },
  {
    name: 'Steglitz-Zehlendorf',
    zeit: '2023-Q4',
    _angebote_kauf: 1282,
    _angebote_miete: 396,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q4',
    _angebote_kauf: 353,
    _angebote_miete: 410,
  },
  {
    name: 'Tempelhof-Schöneberg',
    zeit: '2023-Q4',
    _angebote_kauf: 1168,
    _angebote_miete: 394,
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    zeit: '2023-Q4',
    _angebote_kauf: 1535,
    _angebote_miete: 456,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q4',
    _angebote_kauf: 1595,
    _angebote_miete: 654,
  },
  {
    name: 'Friedrichshain',
    zeit: '2023-Q4',
    _angebote_kauf: 975,
    _angebote_miete: 274,
  },
  {
    name: 'Tempelhof',
    zeit: '2023-Q4',
    _angebote_kauf: 180,
    _angebote_miete: 50,
  },
  {
    name: 'Wedding',
    zeit: '2023-Q4',
    _angebote_kauf: 268,
    _angebote_miete: 103,
  },
  {
    name: 'Kreuzberg',
    zeit: '2023-Q4',
    _angebote_kauf: 556,
    _angebote_miete: 183,
  },
  {
    name: 'Charlottenburg',
    zeit: '2023-Q4',
    _angebote_kauf: 949,
    _angebote_miete: 289,
  },
  {
    name: 'Köpenick',
    zeit: '2023-Q4',
    _angebote_kauf: 299,
    _angebote_miete: 246,
  },
  {
    name: 'Neukölln',
    zeit: '2023-Q4',
    _angebote_kauf: 510,
    _angebote_miete: 192,
  },
  {
    name: 'Steglitz',
    zeit: '2023-Q4',
    _angebote_kauf: 443,
    _angebote_miete: 77,
  },
  {
    name: 'Schöneberg',
    zeit: '2023-Q4',
    _angebote_kauf: 462,
    _angebote_miete: 132,
  },
  {
    name: 'Wilmersdorf',
    zeit: '2023-Q4',
    _angebote_kauf: 817,
    _angebote_miete: 204,
  },
  {
    name: 'Mitte',
    zeit: '2023-Q4',
    _angebote_kauf: 570,
    _angebote_miete: 398,
  },
  {
    name: 'Reinickendorf',
    zeit: '2023-Q4',
    _angebote_kauf: 404,
    _angebote_miete: 104,
  },
  {
    name: 'Pankow',
    zeit: '2023-Q4',
    _angebote_kauf: 243,
    _angebote_miete: 107,
  },
  {
    name: 'Zehlendorf',
    zeit: '2023-Q4',
    _angebote_kauf: 228,
    _angebote_miete: 94,
  },
  {
    name: 'Lichtenberg',
    zeit: '2023-Q4',
    _angebote_kauf: 61,
    _angebote_miete: 23,
  },
  {
    name: 'Spandau',
    zeit: '2023-Q4',
    _angebote_kauf: 177,
    _angebote_miete: 55,
  },
  {
    _angebote_kauf: 471,
    _angebote_miete: 754,
    zeit: '2023-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 471,
    _angebote_miete: 754,
    zeit: '2021-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1121,
    _angebote_miete: 1291,
    zeit: '2021-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 804,
    _angebote_miete: 893,
    zeit: '2021-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 787,
    _angebote_miete: 822,
    zeit: '2021-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 298,
    _angebote_miete: 796,
    zeit: '2021-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 874,
    _angebote_miete: 746,
    zeit: '2021-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 113,
    _angebote_miete: 591,
    zeit: '2021-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 365,
    _angebote_miete: 715,
    zeit: '2021-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1343,
    _angebote_miete: 1655,
    zeit: '2021-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 399,
    _angebote_miete: 676,
    zeit: '2021-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 619,
    _angebote_miete: 1121,
    zeit: '2021-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1565,
    _angebote_miete: 1186,
    zeit: '2021-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1665,
    _angebote_miete: 1290,
    zeit: '2021-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1233,
    _angebote_miete: 1443,
    zeit: '2021-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 950,
    _angebote_miete: 909,
    zeit: '2021-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 850,
    _angebote_miete: 882,
    zeit: '2021-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 339,
    _angebote_miete: 809,
    zeit: '2021-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 919,
    _angebote_miete: 860,
    zeit: '2021-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 128,
    _angebote_miete: 646,
    zeit: '2021-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 360,
    _angebote_miete: 696,
    zeit: '2021-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1442,
    _angebote_miete: 1864,
    zeit: '2021-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 389,
    _angebote_miete: 657,
    zeit: '2021-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 583,
    _angebote_miete: 1171,
    zeit: '2021-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 481,
    _angebote_miete: 883,
    zeit: '2021-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 837,
    _angebote_miete: 715,
    zeit: '2021-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 1336,
    _angebote_miete: 1306,
    zeit: '2021-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1086,
    _angebote_miete: 920,
    zeit: '2021-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 333,
    _angebote_miete: 834,
    zeit: '2021-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 986,
    _angebote_miete: 752,
    zeit: '2021-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 132,
    _angebote_miete: 614,
    zeit: '2021-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 366,
    _angebote_miete: 599,
    zeit: '2021-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1536,
    _angebote_miete: 1798,
    zeit: '2021-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 448,
    _angebote_miete: 634,
    zeit: '2021-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 565,
    _angebote_miete: 1109,
    zeit: '2021-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1740,
    _angebote_miete: 1152,
    zeit: '2021-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 586,
    _angebote_miete: 823,
    zeit: '2021-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 584,
    _angebote_miete: 681,
    zeit: '2021-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1512,
    _angebote_miete: 1171,
    zeit: '2021-Q1',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1130,
    _angebote_miete: 696,
    zeit: '2021-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 969,
    _angebote_miete: 649,
    zeit: '2021-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 340,
    _angebote_miete: 894,
    zeit: '2021-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1034,
    _angebote_miete: 615,
    zeit: '2021-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 117,
    _angebote_miete: 651,
    zeit: '2021-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 398,
    _angebote_miete: 616,
    zeit: '2021-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1632,
    _angebote_miete: 1589,
    zeit: '2021-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 520,
    _angebote_miete: 541,
    zeit: '2021-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 602,
    _angebote_miete: 1146,
    zeit: '2021-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1835,
    _angebote_miete: 1016,
    zeit: '2021-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 2105,
    _angebote_miete: 955,
    zeit: '2020-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1635,
    _angebote_miete: 1126,
    zeit: '2020-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1252,
    _angebote_miete: 776,
    zeit: '2020-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1108,
    _angebote_miete: 730,
    zeit: '2020-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 373,
    _angebote_miete: 982,
    zeit: '2020-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1188,
    _angebote_miete: 646,
    zeit: '2020-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 141,
    _angebote_miete: 723,
    zeit: '2020-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 450,
    _angebote_miete: 750,
    zeit: '2020-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1774,
    _angebote_miete: 1662,
    zeit: '2020-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 525,
    _angebote_miete: 561,
    zeit: '2020-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 719,
    _angebote_miete: 1160,
    zeit: '2020-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 636,
    _angebote_miete: 630,
    zeit: '2020-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 784,
    _angebote_miete: 1196,
    zeit: '2020-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1778,
    _angebote_miete: 1289,
    zeit: '2020-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1311,
    _angebote_miete: 853,
    zeit: '2020-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 675,
    _angebote_miete: 706,
    zeit: '2020-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1107,
    _angebote_miete: 827,
    zeit: '2020-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 352,
    _angebote_miete: 1126,
    zeit: '2020-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1317,
    _angebote_miete: 742,
    zeit: '2020-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 125,
    _angebote_miete: 786,
    zeit: '2020-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 423,
    _angebote_miete: 744,
    zeit: '2020-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1700,
    _angebote_miete: 1805,
    zeit: '2020-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 577,
    _angebote_miete: 588,
    zeit: '2020-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 2155,
    _angebote_miete: 1168,
    zeit: '2020-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 99,
    _angebote_miete: 631,
    zeit: '2020-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 1813,
    _angebote_miete: 1364,
    zeit: '2020-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1243,
    _angebote_miete: 844,
    zeit: '2020-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 928,
    _angebote_miete: 766,
    zeit: '2020-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 369,
    _angebote_miete: 971,
    zeit: '2020-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1316,
    _angebote_miete: 762,
    zeit: '2020-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 366,
    _angebote_miete: 687,
    zeit: '2020-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1532,
    _angebote_miete: 1755,
    zeit: '2020-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 523,
    _angebote_miete: 548,
    zeit: '2020-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 695,
    _angebote_miete: 1115,
    zeit: '2020-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2090,
    _angebote_miete: 1146,
    zeit: '2020-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 690,
    _angebote_miete: 714,
    zeit: '2020-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 679,
    _angebote_miete: 850,
    zeit: '2020-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1814,
    _angebote_miete: 1509,
    zeit: '2020-Q1',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1215,
    _angebote_miete: 1033,
    zeit: '2020-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 991,
    _angebote_miete: 874,
    zeit: '2020-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 370,
    _angebote_miete: 1045,
    zeit: '2020-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1238,
    _angebote_miete: 837,
    zeit: '2020-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 118,
    _angebote_miete: 674,
    zeit: '2020-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 382,
    _angebote_miete: 748,
    zeit: '2020-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1585,
    _angebote_miete: 1873,
    zeit: '2020-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 514,
    _angebote_miete: 637,
    zeit: '2020-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 720,
    _angebote_miete: 1302,
    zeit: '2020-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2183,
    _angebote_miete: 1348,
    zeit: '2020-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 2245,
    _angebote_miete: 1547,
    zeit: '2019-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1851,
    _angebote_miete: 1768,
    zeit: '2019-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1178,
    _angebote_miete: 1192,
    zeit: '2019-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1028,
    _angebote_miete: 987,
    zeit: '2019-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 374,
    _angebote_miete: 1044,
    zeit: '2019-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1234,
    _angebote_miete: 1036,
    zeit: '2019-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 94,
    _angebote_miete: 869,
    zeit: '2019-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 362,
    _angebote_miete: 910,
    zeit: '2019-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1493,
    _angebote_miete: 2122,
    zeit: '2019-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 496,
    _angebote_miete: 845,
    zeit: '2019-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 734,
    _angebote_miete: 1327,
    zeit: '2019-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 609,
    _angebote_miete: 915,
    zeit: '2019-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 983,
    _angebote_miete: 1161,
    zeit: '2019-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 1558,
    _angebote_miete: 2092,
    zeit: '2019-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1023,
    _angebote_miete: 1332,
    zeit: '2019-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 402,
    _angebote_miete: 1225,
    zeit: '2019-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1197,
    _angebote_miete: 1191,
    zeit: '2019-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 93,
    _angebote_miete: 1028,
    zeit: '2019-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 398,
    _angebote_miete: 1166,
    zeit: '2019-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1438,
    _angebote_miete: 2107,
    zeit: '2019-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 544,
    _angebote_miete: 982,
    zeit: '2019-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 696,
    _angebote_miete: 1561,
    zeit: '2019-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2099,
    _angebote_miete: 1711,
    zeit: '2019-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 676,
    _angebote_miete: 997,
    zeit: '2019-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 585,
    _angebote_miete: 696,
    zeit: '2019-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1364,
    _angebote_miete: 1465,
    zeit: '2019-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 922,
    _angebote_miete: 909,
    zeit: '2019-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 831,
    _angebote_miete: 849,
    zeit: '2019-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 394,
    _angebote_miete: 840,
    zeit: '2019-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1009,
    _angebote_miete: 901,
    zeit: '2019-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 81,
    _angebote_miete: 725,
    zeit: '2019-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 317,
    _angebote_miete: 940,
    zeit: '2019-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1181,
    _angebote_miete: 1684,
    zeit: '2019-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 496,
    _angebote_miete: 629,
    zeit: '2019-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 571,
    _angebote_miete: 1187,
    zeit: '2019-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1893,
    _angebote_miete: 1347,
    zeit: '2019-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 2103,
    _angebote_miete: 1545,
    zeit: '2019-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1338,
    _angebote_miete: 1761,
    zeit: '2019-Q1',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 907,
    _angebote_miete: 1058,
    zeit: '2019-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 779,
    _angebote_miete: 938,
    zeit: '2019-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 337,
    _angebote_miete: 892,
    zeit: '2019-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 948,
    _angebote_miete: 1046,
    zeit: '2019-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 100,
    _angebote_miete: 751,
    zeit: '2019-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 306,
    _angebote_miete: 1121,
    zeit: '2019-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1187,
    _angebote_miete: 1806,
    zeit: '2019-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 458,
    _angebote_miete: 801,
    zeit: '2019-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 526,
    _angebote_miete: 1422,
    zeit: '2019-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 665,
    _angebote_miete: 973,
    zeit: '2019-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 469,
    _angebote_miete: 820,
    zeit: '2018-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 1248,
    _angebote_miete: 1799,
    zeit: '2018-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 877,
    _angebote_miete: 1092,
    zeit: '2018-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1986,
    _angebote_miete: 1468,
    zeit: '2018-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 783,
    _angebote_miete: 1018,
    zeit: '2018-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 348,
    _angebote_miete: 828,
    zeit: '2018-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 942,
    _angebote_miete: 1071,
    zeit: '2018-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 567,
    _angebote_miete: 957,
    zeit: '2018-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 98,
    _angebote_miete: 799,
    zeit: '2018-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 312,
    _angebote_miete: 1002,
    zeit: '2018-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1258,
    _angebote_miete: 1912,
    zeit: '2018-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 499,
    _angebote_miete: 1412,
    zeit: '2018-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 560,
    _angebote_miete: 910,
    zeit: '2018-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1917,
    _angebote_miete: 1600,
    zeit: '2018-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 491,
    _angebote_miete: 1322,
    zeit: '2018-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 482,
    _angebote_miete: 836,
    zeit: '2018-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 1197,
    _angebote_miete: 2094,
    zeit: '2018-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 346,
    _angebote_miete: 990,
    zeit: '2018-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 79,
    _angebote_miete: 673,
    zeit: '2018-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 880,
    _angebote_miete: 1054,
    zeit: '2018-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 382,
    _angebote_miete: 791,
    zeit: '2018-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 797,
    _angebote_miete: 1028,
    zeit: '2018-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 945,
    _angebote_miete: 1148,
    zeit: '2018-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1217,
    _angebote_miete: 1692,
    zeit: '2018-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 582,
    _angebote_miete: 984,
    zeit: '2018-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1212,
    _angebote_miete: 1767,
    zeit: '2018-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 995,
    _angebote_miete: 1142,
    zeit: '2018-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 788,
    _angebote_miete: 1097,
    zeit: '2018-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 408,
    _angebote_miete: 720,
    zeit: '2018-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 817,
    _angebote_miete: 1095,
    zeit: '2018-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 88,
    _angebote_miete: 678,
    zeit: '2018-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 342,
    _angebote_miete: 985,
    zeit: '2018-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1231,
    _angebote_miete: 1979,
    zeit: '2018-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 425,
    _angebote_miete: 771,
    zeit: '2018-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 504,
    _angebote_miete: 1341,
    zeit: '2018-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1887,
    _angebote_miete: 1648,
    zeit: '2018-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1810,
    _angebote_miete: 1680,
    zeit: '2018-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1131,
    _angebote_miete: 1794,
    zeit: '2018-Q1',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 909,
    _angebote_miete: 1188,
    zeit: '2018-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 793,
    _angebote_miete: 1021,
    zeit: '2018-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 402,
    _angebote_miete: 752,
    zeit: '2018-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 842,
    _angebote_miete: 1101,
    zeit: '2018-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 100,
    _angebote_miete: 678,
    zeit: '2018-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 361,
    _angebote_miete: 970,
    zeit: '2018-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1215,
    _angebote_miete: 1988,
    zeit: '2018-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 423,
    _angebote_miete: 802,
    zeit: '2018-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 553,
    _angebote_miete: 1492,
    zeit: '2018-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 574,
    _angebote_miete: 937,
    zeit: '2018-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 823,
    _angebote_miete: 979,
    zeit: '2017-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 1207,
    _angebote_miete: 1862,
    zeit: '2017-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1018,
    _angebote_miete: 1118,
    zeit: '2017-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 440,
    _angebote_miete: 727,
    zeit: '2017-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 943,
    _angebote_miete: 1109,
    zeit: '2017-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 144,
    _angebote_miete: 708,
    zeit: '2017-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 442,
    _angebote_miete: 908,
    zeit: '2017-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1294,
    _angebote_miete: 2007,
    zeit: '2017-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 490,
    _angebote_miete: 756,
    zeit: '2017-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 645,
    _angebote_miete: 1443,
    zeit: '2017-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1949,
    _angebote_miete: 1773,
    zeit: '2017-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 587,
    _angebote_miete: 933,
    zeit: '2017-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 599,
    _angebote_miete: 903,
    zeit: '2017-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1384,
    _angebote_miete: 2116,
    zeit: '2017-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1087,
    _angebote_miete: 1185,
    zeit: '2017-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 933,
    _angebote_miete: 1043,
    zeit: '2017-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 534,
    _angebote_miete: 774,
    zeit: '2017-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1013,
    _angebote_miete: 1288,
    zeit: '2017-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 135,
    _angebote_miete: 757,
    zeit: '2017-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 454,
    _angebote_miete: 1029,
    zeit: '2017-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1332,
    _angebote_miete: 2236,
    zeit: '2017-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 494,
    _angebote_miete: 809,
    zeit: '2017-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 729,
    _angebote_miete: 1556,
    zeit: '2017-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2128,
    _angebote_miete: 1951,
    zeit: '2017-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 2269,
    _angebote_miete: 1994,
    zeit: '2017-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1491,
    _angebote_miete: 2081,
    zeit: '2017-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1056,
    _angebote_miete: 1117,
    zeit: '2017-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1008,
    _angebote_miete: 1121,
    zeit: '2017-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 517,
    _angebote_miete: 789,
    zeit: '2017-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1069,
    _angebote_miete: 1445,
    zeit: '2017-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 124,
    _angebote_miete: 826,
    zeit: '2017-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 429,
    _angebote_miete: 1089,
    zeit: '2017-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1331,
    _angebote_miete: 2301,
    zeit: '2017-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 485,
    _angebote_miete: 876,
    zeit: '2017-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 748,
    _angebote_miete: 1565,
    zeit: '2017-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 572,
    _angebote_miete: 999,
    zeit: '2017-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 795,
    _angebote_miete: 1630,
    zeit: '2017-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 1498,
    _angebote_miete: 2182,
    zeit: '2017-Q1',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1119,
    _angebote_miete: 1411,
    zeit: '2017-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 477,
    _angebote_miete: 1492,
    zeit: '2017-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1029,
    _angebote_miete: 1243,
    zeit: '2017-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 398,
    _angebote_miete: 881,
    zeit: '2017-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1079,
    _angebote_miete: 1558,
    zeit: '2017-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 129,
    _angebote_miete: 989,
    zeit: '2017-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 448,
    _angebote_miete: 1203,
    zeit: '2017-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1269,
    _angebote_miete: 2537,
    zeit: '2017-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 443,
    _angebote_miete: 904,
    zeit: '2017-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 2269,
    _angebote_miete: 2093,
    zeit: '2017-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 444,
    _angebote_miete: 1474,
    zeit: '2016-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1550,
    _angebote_miete: 2095,
    zeit: '2016-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1078,
    _angebote_miete: 1353,
    zeit: '2016-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1103,
    _angebote_miete: 1270,
    zeit: '2016-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 496,
    _angebote_miete: 861,
    zeit: '2016-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1214,
    _angebote_miete: 1377,
    zeit: '2016-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 138,
    _angebote_miete: 892,
    zeit: '2016-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 483,
    _angebote_miete: 1166,
    zeit: '2016-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1321,
    _angebote_miete: 2437,
    zeit: '2016-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 491,
    _angebote_miete: 831,
    zeit: '2016-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 783,
    _angebote_miete: 1437,
    zeit: '2016-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2475,
    _angebote_miete: 2012,
    zeit: '2016-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 501,
    _angebote_miete: 1411,
    zeit: '2016-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1690,
    _angebote_miete: 2323,
    zeit: '2016-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1254,
    _angebote_miete: 1568,
    zeit: '2016-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1204,
    _angebote_miete: 1401,
    zeit: '2016-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 418,
    _angebote_miete: 926,
    zeit: '2016-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1301,
    _angebote_miete: 1600,
    zeit: '2016-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 141,
    _angebote_miete: 1021,
    zeit: '2016-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 508,
    _angebote_miete: 1186,
    zeit: '2016-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1404,
    _angebote_miete: 2502,
    zeit: '2016-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 577,
    _angebote_miete: 1004,
    zeit: '2016-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 945,
    _angebote_miete: 1649,
    zeit: '2016-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2719,
    _angebote_miete: 2293,
    zeit: '2016-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 2907,
    _angebote_miete: 2339,
    zeit: '2016-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1793,
    _angebote_miete: 2252,
    zeit: '2016-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1385,
    _angebote_miete: 1524,
    zeit: '2016-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1288,
    _angebote_miete: 1464,
    zeit: '2016-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 376,
    _angebote_miete: 931,
    zeit: '2016-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1341,
    _angebote_miete: 1654,
    zeit: '2016-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 143,
    _angebote_miete: 976,
    zeit: '2016-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 473,
    _angebote_miete: 1219,
    zeit: '2016-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1573,
    _angebote_miete: 2750,
    zeit: '2016-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 572,
    _angebote_miete: 1122,
    zeit: '2016-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 951,
    _angebote_miete: 1627,
    zeit: '2016-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 515,
    _angebote_miete: 1517,
    zeit: '2016-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 3123,
    _angebote_miete: 2145,
    zeit: '2016-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1852,
    _angebote_miete: 2140,
    zeit: '2016-Q1',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1414,
    _angebote_miete: 1315,
    zeit: '2016-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1189,
    _angebote_miete: 1362,
    zeit: '2016-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 443,
    _angebote_miete: 934,
    zeit: '2016-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1368,
    _angebote_miete: 1558,
    zeit: '2016-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 148,
    _angebote_miete: 984,
    zeit: '2016-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 448,
    _angebote_miete: 1134,
    zeit: '2016-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1661,
    _angebote_miete: 2689,
    zeit: '2016-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 567,
    _angebote_miete: 1049,
    zeit: '2016-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 1032,
    _angebote_miete: 1514,
    zeit: '2016-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 550,
    _angebote_miete: 1425,
    zeit: '2016-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 156,
    _angebote_miete: 653,
    zeit: '2015-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 1626,
    _angebote_miete: 1176,
    zeit: '2015-Q4',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1356,
    _angebote_miete: 680,
    zeit: '2015-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1163,
    _angebote_miete: 763,
    zeit: '2015-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 410,
    _angebote_miete: 611,
    zeit: '2015-Q4',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1298,
    _angebote_miete: 786,
    zeit: '2015-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 413,
    _angebote_miete: 661,
    zeit: '2015-Q4',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1524,
    _angebote_miete: 1349,
    zeit: '2015-Q4',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 481,
    _angebote_miete: 580,
    zeit: '2015-Q4',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 981,
    _angebote_miete: 905,
    zeit: '2015-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 2949,
    _angebote_miete: 1324,
    zeit: '2015-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 531,
    _angebote_miete: 671,
    zeit: '2015-Q4',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 512,
    _angebote_miete: 1240,
    zeit: '2015-Q3',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 2075,
    _angebote_miete: 2519,
    zeit: '2015-Q3',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1626,
    _angebote_miete: 1470,
    zeit: '2015-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1327,
    _angebote_miete: 1508,
    zeit: '2015-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 520,
    _angebote_miete: 1182,
    zeit: '2015-Q3',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1502,
    _angebote_miete: 1658,
    zeit: '2015-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 191,
    _angebote_miete: 1124,
    zeit: '2015-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 460,
    _angebote_miete: 1207,
    zeit: '2015-Q3',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1716,
    _angebote_miete: 2884,
    zeit: '2015-Q3',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 554,
    _angebote_miete: 1145,
    zeit: '2015-Q3',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 1130,
    _angebote_miete: 1747,
    zeit: '2015-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 3537,
    _angebote_miete: 2606,
    zeit: '2015-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 3606,
    _angebote_miete: 3267,
    zeit: '2015-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 2283,
    _angebote_miete: 2982,
    zeit: '2015-Q2',
    name: 'Pankow',
  },
  {
    _angebote_kauf: 1720,
    _angebote_miete: 1888,
    zeit: '2015-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 1402,
    _angebote_miete: 1872,
    zeit: '2015-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 571,
    _angebote_miete: 1201,
    zeit: '2015-Q2',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1601,
    _angebote_miete: 1939,
    zeit: '2015-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 177,
    _angebote_miete: 1122,
    zeit: '2015-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 500,
    _angebote_miete: 1287,
    zeit: '2015-Q2',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 1922,
    _angebote_miete: 3257,
    zeit: '2015-Q2',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 607,
    _angebote_miete: 1248,
    zeit: '2015-Q2',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 1233,
    _angebote_miete: 1804,
    zeit: '2015-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 550,
    _angebote_miete: 1366,
    zeit: '2015-Q2',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 1756,
    _angebote_miete: 2013,
    zeit: '2015-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    _angebote_kauf: 3411,
    _angebote_miete: 3365,
    zeit: '2015-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    _angebote_kauf: 1221,
    _angebote_miete: 1883,
    zeit: '2015-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    _angebote_kauf: 546,
    _angebote_miete: 1316,
    zeit: '2015-Q1',
    name: 'Reinickendorf',
  },
  {
    _angebote_kauf: 2091,
    _angebote_miete: 3354,
    zeit: '2015-Q1',
    name: 'Mitte',
  },
  {
    _angebote_kauf: 557,
    _angebote_miete: 1390,
    zeit: '2015-Q1',
    name: 'Spandau',
  },
  {
    _angebote_kauf: 625,
    _angebote_miete: 1500,
    zeit: '2015-Q1',
    name: 'Neukölln',
  },
  {
    _angebote_kauf: 215,
    _angebote_miete: 1202,
    zeit: '2015-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    _angebote_kauf: 1631,
    _angebote_miete: 2184,
    zeit: '2015-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    _angebote_kauf: 586,
    _angebote_miete: 1122,
    zeit: '2015-Q1',
    name: 'Lichtenberg',
  },
  {
    _angebote_kauf: 1357,
    _angebote_miete: 2061,
    zeit: '2015-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    _angebote_kauf: 2365,
    _angebote_miete: 3225,
    zeit: '2015-Q1',
    name: 'Pankow',
  },
]
